import { Button, Grid } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import React, { useContext, useMemo, useState } from "react";
import { useIntl } from "react-intl";

import { CustomerContext } from "../../CollectionFormSubmit";
import useStyles from "../styles";
import ShippingModal from "./../ModalShipping";
import Address from "./Address";

interface Props {
  address?: any[];
}

export enum ShippingTypeEnum {
  Delivery,
  TaxInvoices
}
const Shipping: React.FC<Props> = ({ address }) => {
  const classes = useStyles();
  const intl = useIntl();
  const { formik } = useContext(CustomerContext);
  const [visible, setVisible] = useState<boolean>(false);
  const [shippingType, setShippingType] = useState<ShippingTypeEnum>(
    ShippingTypeEnum.Delivery
  );
  const handleApplyShipping = (value: string) => {
    if (shippingType === ShippingTypeEnum.Delivery) {
      formik.setFieldValue("shipTo", value);
    } else {
      formik.setFieldValue("billTo", value);
    }
  };

  const shippingAddressValue = useMemo(() => formik.values?.shipTo, [
    formik.values?.shipTo
  ]);
  const billingAddressValue = useMemo(() => formik.values?.billTo, [
    formik.values?.billTo
  ]);

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <div className={classes.shippingAddress}>
            <MyTypography variant="subtitle3" className={classes.labelAddress}>
              {intl.formatMessage({
                defaultMessage: "สถานที่จัดส่งสินค้า",
                description: "label"
              })}
              <span className={classes.required}>*</span>
            </MyTypography>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              onClick={() => {
                setVisible(true);
                setShippingType(ShippingTypeEnum.Delivery);
              }}
              className={classes.btnAddress}
            >
              {intl.formatMessage({
                defaultMessage: "แก้ไข",
                description: "label"
              })}
            </Button>
          </div>
          <Address address={shippingAddressValue} />
        </Grid>
        <Grid item xs={12} md={6}>
          <div className={classes.shippingAddress}>
            <MyTypography variant="subtitle3" className={classes.labelAddress}>
              {intl.formatMessage({
                defaultMessage: "ที่อยู่สำหรับออกใบกำกับภาษี",
                description: "label"
              })}
              <span className={classes.required}>*</span>
            </MyTypography>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              onClick={() => {
                setVisible(true);
                setShippingType(ShippingTypeEnum.TaxInvoices);
              }}
              className={classes.btnAddress}
            >
              {intl.formatMessage({
                defaultMessage: "แก้ไข",
                description: "label"
              })}
            </Button>
          </div>
          <Address address={billingAddressValue} />
        </Grid>
      </Grid>
      {visible && (
        <ShippingModal
          visible
          onClose={() => setVisible(false)}
          type={shippingType}
          address={address}
          handleApplyShipping={handleApplyShipping}
        />
      )}
    </>
  );
};

export default Shipping;
